import React from "react";
import { Row } from "reactstrap";

export default function ObDisclaimer(props) {

  const marginForWeb = {
    marginBottom: !props?.isMobile ? "4rem" : "0rem"
  }

  return (
    <Row className="m-2">
      <div style={marginForWeb}>
        <p className="font-weight-semi-bold w-100 font-size-18 mt-5 mb-4">
          Disclaimer 
        </p>
        <p className="font-size-10" style={{textAlign: 'justify'}}>
          Investments in debt securities/municipal debt securities/securitised debt instruments are subject to risks including delay and/or default in payment. Read all the offer related documents carefully.<br/>
          The information contained herein is only to enable the Investor (or Lender) to make an informed decision. Any decision
          taken by the investor on the basis of this information is the sole responsibility of the Investor (Lender) and Bidd is not liable. Bidd has partnered with a third party platform regarding investments in various alternate 
          investment opportunities. Bidd will not be responsible for the full or partial loss of the principal and/or 
          interest of the investor’s investment. Bidd is only an intermediary introducing these third party services and 
          is not responsible for any agreement you sign with the third party.<br/>
          Oro Financial Consultants Pvt Ltd is the Stock broker entity operating in cash and debt segment having SEBI registration number: INZ000312534, Registered as an Online Bond Platform Provider in BSE Ltd.(Member Code: 6821) 
          and National Stock Exchange of India Limited (Member Code: 90389)<br/>
          {/* The OBPP platform is a wholly owned subsidiary of Alpha Fintech Private Limited, which is acting as a seller for debt securities.<br /> */}
          MLD's/Bonds issued by InCred Financial Services Limited, which is a Group Company of Oro Financial Consultants Private Limited are also listed on the OBPP platform.
        </p>
      </div>
    </Row>
  );
}
